var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSiteLocator = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-537 -432)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "sitelocator",
    width: 18,
    height: 18,
    transform: "translate(537 432)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1.1a4.7,4.7,0,0,1,4.7,4.7,6.419,6.419,0,0,1-.5,2A55.528,55.528,0,0,1,9,13.9,46.423,46.423,0,0,1,4.6,7.7a5.23,5.23,0,0,1-.3-1.8A4.781,4.781,0,0,1,9,1.1M9,0A5.911,5.911,0,0,0,3.1,5.9a5.932,5.932,0,0,0,.5,2.3C4.5,10.1,9,15.8,9,15.8a72.616,72.616,0,0,0,5.3-7.4,6.457,6.457,0,0,0,.6-2.5A5.911,5.911,0,0,0,9,0Z",
    transform: "translate(537 432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,4.1A1.8,1.8,0,1,1,7.2,5.9,1.793,1.793,0,0,1,9,4.1M9,3A3.009,3.009,0,0,0,6,6,2.946,2.946,0,0,0,9,9a2.946,2.946,0,0,0,3-3A3.009,3.009,0,0,0,9,3Z",
    transform: "translate(537 432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,11.9a8.65,8.65,0,0,0-.7,1c1.7.5,2.7,1.2,2.7,1.7,0,.8-2.6,2.2-6.8,2.2s-6.8-1.5-6.8-2.2c0-.5,1-1.3,2.8-1.8a8.65,8.65,0,0,1-.7-1c-2,.6-3.2,1.6-3.2,2.7.1,2,3.7,3.5,8,3.5s7.9-1.5,7.9-3.4C16.9,13.5,15.6,12.5,13.7,11.9Z",
    transform: "translate(537 432)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSiteLocator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/site-locator.c8188e1502744cf1d38a720ae86f2ab0.svg";